"use client";
import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import Link from 'next/link'
import { gsap } from "gsap";
import { usePathname } from "next/navigation";


export default function LogoFooter(
    {
        singleLogoForPc=false,
        classLink='',
    }:
    {
        singleLogoForPc?: boolean;
        classLink? : string;
    }
) {

    const pathname = usePathname();
    const [pageType, setPageType] = useState<string>('home');

    const footerLogoRef = useRef<HTMLVideoElement>(null);
    const footerLogoImgRef = useRef<HTMLImageElement>(null);

    const playLogo = () => {
        const tlLogo = gsap.timeline({paused: true});
        tlLogo.to(footerLogoRef.current, {opacity: 1, duration: 0.3, onComplete: ()=>{footerLogoRef.current?.play();}})
            .to(footerLogoImgRef.current, {opacity: 0, duration: 0.6}, '<')
            .to(footerLogoRef.current, {opacity: 0, duration: 0.3, clearProps: 'opacity'}, '2.5')
            .to(footerLogoImgRef.current, {opacity: 1, duration: 0.6, clearProps: 'opacity'}, '2.2')

        if(footerLogoRef.current) {
            tlLogo.play();
        }
    }

    useEffect(() => {
        const hereIsHome = pathname == '/';
        const hereIsProject = pathname.includes('/projects/');

        if(hereIsHome) {
            setPageType('home');
        } else if(hereIsProject) {
            setPageType('project');
        } else {
            setPageType('other');
        }
    }, [pathname])

    return (
        <Link onMouseEnter={playLogo} className={`js-footer-logo ${pageType == 'home' && 'top-[84svh] bottom-auto left-[10px] w-[82vw] lg:top-auto lg:bottom-[3vw] lg:left-[20px] lg:w-[54vw]'} ${pageType == 'project' && 'bottom-0 left-[3px] w-[300px] rotate-90 -translate-y-[300px] lg:right-[20px] lg:left-auto'} ${pageType == 'other' && 'bottom-0 left-[3px] w-[300px] rotate-90 -translate-y-[300px] lg:left-[20px] lg:right-auto'} absolute origin-bottom-left lg:bottom-0 lg:transform-none lg:w-[56vw] [mix-blend-mode:multiply] z-10`} href='/'>
            <Image
                ref={footerLogoImgRef}
                src='/images/svg/logo-sd.svg'
                width={300}
                height={41}
                className="w-full h-auto"
                alt='seitaro design'
                priority
            />
            <video ref={footerLogoRef} src="/movies/footer_logo.mp4" muted playsInline className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-[1.038] w-full h-auto [mix-blend-mode:color-burn;] opacity-0"></video>
        </Link>
    );
}
